var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panel-container"},[_c('panel-map',{staticClass:"panel-container__map"}),_c('panel-scheduled-activities',{staticClass:"panel-container__scheduled-activities"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }